import React from "react";
import styles from "./ArchiveResultCounter.module.scss";

type Props = { current: string | number; total: string | number };
const ArchiveResultCounter: React.FC<Props> = ({ current, total }) => {
  return <div className={styles["count"]}>{`${current}/${total}件`}</div>;
};

export default ArchiveResultCounter;
